module.exports = __webpack_public_path__ + "static/468x60.f21e7770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/multimedia/2019/468x60.jpg
// module id = 565
// module chunks = 116596815971312